import { FC } from "react";
import { Theme } from "../../../types";
import { megaMenuGroupTitle } from "../../styles";
import { useTranslations } from "use-intl";

interface MegaMenuGroupTitleProps {
  groupKey: string;
  theme: Theme;
}

/**
 * 二级展开菜单 - 分组标题
 *
 * 用于 Mega Menu 内的分组标题（如 "Trading"、"Explore"、"Promo"）
 * 当 groupKey 以 "__" 开头时（如 "__widget__"），不渲染标题
 */
const MegaMenuGroupTitle: FC<MegaMenuGroupTitleProps> = ({ groupKey, theme }) => {
  const t = useTranslations("header");

  // 以 __ 开头的 key 为内部约定 key（如 __widget__），不显示标题
  if (groupKey.startsWith("__")) return null;

  return <div className={megaMenuGroupTitle({ mode: theme })}>{t(groupKey)}</div>;
};

export default MegaMenuGroupTitle;
